import api from '../../../api/clinique/_analyses'

export default {
    getAnalyses() {
        return new Promise((resolve) => {
            api.getAnalyses().then((response) => {
                resolve(response);
            });
        });
    },

    getCategoriesAnalyse() {
        return new Promise((resolve) => {
            api.getCategoriesAnalyse().then((response) => {
                resolve(response);
            });
        });
    },

    getAllAnalysesForExterne() {
        return new Promise((resolve, reject) => {
            api.getAllAnalysesForExterne().then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
}